import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from '@/utils/axios'
import Qs from 'qs'
import 'lib-flexible'

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$qs = Qs

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
